export enum NotificationTypes {
	success = 'success',
	warning = 'warning',
	error = 'error'
}